
export enum StatusKeys {
  Invalid = -1,
  NotSet = 0,
  Planning = 1,
  Recording = 2,
  ReadyToEdit = 3,
  Editing = 4,
  ReadyForCustomerReview = 5,
  NeedMoreWork = 6,
  Approved = 7,
  Publishing = 8,
  Published = 9,
  ReadyForOpsReview = 10,
}
